/* Portado VERBATIM desde boston_ia/index.html — logica original respetada.
   Fuente: C:\\xampp\\htdocs\\boston_ia\\index.html */
const COMMANDS = [
  // ============ ACCESO Y SESION ============
  { c:'Acceso', cmd:'SI*1234', m:'Sign in con EPR/clave.' },
  { c:'Acceso', cmd:'SI*1234/AGENT', m:'Sign in con agent y password.' },
  { c:'Acceso', cmd:'SO*', m:'Sign out de todas las areas.' },
  { c:'Acceso', cmd:'SO', m:'Sign out del area activa.' },
  { c:'Acceso', cmd:'*S*', m:'Lista areas de trabajo activas (A-F).' },
  { c:'Acceso', cmd:'JM', m:'Cambia al area de trabajo siguiente.' },
  { c:'Acceso', cmd:'JMA', m:'Cambia al area de trabajo A.' },
  { c:'Acceso', cmd:'JMB', m:'Cambia al area de trabajo B.' },
  { c:'Acceso', cmd:'JE', m:'Termina sesion en el area activa.' },
  { c:'Acceso', cmd:'AAA O5SF', m:'Cambia PCC al codigo dado (Basset ARG).' },
  { c:'Acceso', cmd:'AAA C65I', m:'Cambia PCC (Basset URU).' },
  { c:'Acceso', cmd:'*PCC', m:'Muestra PCC activa.' },
  { c:'Acceso', cmd:'*Q', m:'Estado de queue.' },

  // ============ ENCODE / DECODE ============
  { c:'Encode/Decode', cmd:'W/*BA', m:'Decode aerolinea BA (British Airways).' },
  { c:'Encode/Decode', cmd:'W/-BRITISH', m:'Encode aerolinea por nombre.' },
  { c:'Encode/Decode', cmd:'W/EZE', m:'Decode aeropuerto/ciudad.' },
  { c:'Encode/Decode', cmd:'W/*ARG', m:'Decode pais.' },
  { c:'Encode/Decode', cmd:'W/-ARGENTINA', m:'Encode pais.' },
  { c:'Encode/Decode', cmd:'W/EQP737', m:'Decode tipo de avion.' },
  { c:'Encode/Decode', cmd:'DC*BUE', m:'Display city info.' },
  { c:'Encode/Decode', cmd:'DC*MIA/T', m:'Time zone de la ciudad.' },

  // ============ DISPONIBILIDAD AEREA ============
  { c:'Disponibilidad', cmd:'1', m:'Mantiene la disponibilidad pero re-display.' },
  { c:'Disponibilidad', cmd:'115DECBUEMIA', m:'Disponibilidad basica fecha+OD.' },
  { c:'Disponibilidad', cmd:'115DECBUEMIA8A', m:'Disp con hora preferida.' },
  { c:'Disponibilidad', cmd:'115DECBUEMIA-Y', m:'Disp por clase Y.' },
  { c:'Disponibilidad', cmd:'1*', m:'Siguiente pagina de disponibilidad.' },
  { c:'Disponibilidad', cmd:'1$', m:'Pagina anterior.' },
  { c:'Disponibilidad', cmd:'1*R', m:'Redisplay ultima disp.' },
  { c:'Disponibilidad', cmd:'1R15DEC', m:'Disp de retorno fecha.' },
  { c:'Disponibilidad', cmd:'1‡AA', m:'Disp solo aerolinea AA.' },
  { c:'Disponibilidad', cmd:'1¤AA', m:'Direct Access al inventario AA.' },
  { c:'Disponibilidad', cmd:'115DEC/15DECBUEMIAMIASCL', m:'Disp multi-segmento.' },
  { c:'Disponibilidad', cmd:'S*BA245/15DEC', m:'Schedule vuelo especifico.' },
  { c:'Disponibilidad', cmd:'SE15DECBUEMIA', m:'Schedule completo OD.' },

  // ============ VENTA AEREA ============
  { c:'Venta', cmd:'01Y1', m:'Vende 1 asiento clase Y linea 1.' },
  { c:'Venta', cmd:'02Y1', m:'Vende 2 asientos clase Y linea 1.' },
  { c:'Venta', cmd:'01Y1*', m:'Vende con waitlist activado.' },
  { c:'Venta', cmd:'0AA123Y15DECBUEMIANN1', m:'Long sell directo.' },
  { c:'Venta', cmd:'0AA123Y15DECBUEMIAGK1', m:'Segmento pasivo (GK).' },
  { c:'Venta', cmd:'0AA123Y15DECBUEMIASS1', m:'Sold (sin disponibilidad consult).' },
  { c:'Venta', cmd:'0A', m:'Agrega ARNK/surface segment.' },
  { c:'Venta', cmd:'0OPN', m:'Open segment.' },
  { c:'Venta', cmd:'0OPNAA15DECBUEMIANS1', m:'Open segment con datos.' },
  { c:'Venta', cmd:'0INFLT', m:'In-flight info.' },

  // ============ HOTELES ============
  { c:'Hoteles', cmd:'HOT15DEC-18DECMIA', m:'Disp hoteles MIA.' },
  { c:'Hoteles', cmd:'HOT15DEC-18DEC/MIA/CC-HI', m:'Disp por cadena Holiday Inn.' },
  { c:'Hoteles', cmd:'HOT15DEC-18DEC/MIA/RT-DBL', m:'Por room type.' },
  { c:'Hoteles', cmd:'HRG1', m:'Reglas del hotel linea 1.' },
  { c:'Hoteles', cmd:'HRD1', m:'Descripcion del hotel.' },
  { c:'Hoteles', cmd:'HRR1', m:'Rate rules.' },
  { c:'Hoteles', cmd:'HRI1', m:'Imagen del hotel.' },
  { c:'Hoteles', cmd:'HRA1', m:'Amenities.' },
  { c:'Hoteles', cmd:'HF1', m:'Info detallada hotel.' },
  { c:'Hoteles', cmd:'0HHLMCGK1MIA15DEC-18DEC/DBLB/G-CCAX370000000000000EXP1226', m:'Venta hotel pasivo con garantia.' },
  { c:'Hoteles', cmd:'HS1/SI-LATE CHECK IN', m:'Special instruction al hotel.' },
  { c:'Hoteles', cmd:'HS1/SI-EARLY ARRIVAL', m:'Special instruction.' },
  { c:'Hoteles', cmd:'HX1', m:'Cancela segmento hotel 1.' },
  { c:'Hoteles', cmd:'*HTL', m:'Display solo segmentos hotel del PNR.' },

  // ============ AUTOS ============
  { c:'Autos', cmd:'CF15DEC-18DECMIA', m:'Disp autos MIA.' },
  { c:'Autos', cmd:'CF15DEC-18DECMIA/ECAR', m:'Disp por categoria ECAR.' },
  { c:'Autos', cmd:'CF15DEC-18DEC/MIA/1000-1000', m:'Con horas pickup/return.' },
  { c:'Autos', cmd:'CQ1', m:'Cotizacion auto linea 1.' },
  { c:'Autos', cmd:'CC1/RC-12345ABC', m:'Agrega confirmation number.' },
  { c:'Autos', cmd:'0CCRZIGK1MIA15DEC-18DEC/ECAR', m:'Venta auto pasiva Avis.' },
  { c:'Autos', cmd:'0CCRZD1MIA15DEC-18DEC/CCAR', m:'Venta auto Budget.' },
  { c:'Autos', cmd:'CX1', m:'Cancela auto linea 1.' },
  { c:'Autos', cmd:'*CAR', m:'Display solo segmentos auto.' },

  // ============ NOMBRES (Pasajeros) ============
  { c:'Pasajeros', cmd:'-PEREZ/JUAN', m:'Agrega adulto.' },
  { c:'Pasajeros', cmd:'-PEREZ/JUAN MR', m:'Adulto con titulo.' },
  { c:'Pasajeros', cmd:'-2PEREZ/JUAN MR/MARIA MRS', m:'Dos pax mismo apellido.' },
  { c:'Pasajeros', cmd:'-I/PEREZ/SOFIA MISS*DOB29MAY24', m:'Infante con DOB.' },
  { c:'Pasajeros', cmd:'-PEREZ/MARTIN*C08', m:'Nino con edad.' },
  { c:'Pasajeros', cmd:'-2.1¤PEREZ/JUAN', m:'Modifica nombre del pax 2.1.' },
  { c:'Pasajeros', cmd:'-1.1¤', m:'Borra nombre pax 1.1.' },
  { c:'Pasajeros', cmd:'*N', m:'Display nombres.' },

  // ============ TELEFONOS ============
  { c:'Telefonos', cmd:'9BUE45551234-A', m:'Tel agency.' },
  { c:'Telefonos', cmd:'9BUE45551234-B', m:'Tel business.' },
  { c:'Telefonos', cmd:'9BUE45551234-H', m:'Tel home.' },
  { c:'Telefonos', cmd:'9BUE45551234-F', m:'Fax.' },
  { c:'Telefonos', cmd:'9BUE45551234-M', m:'Tel mobile.' },
  { c:'Telefonos', cmd:'9¤2-B', m:'Borra telefono 2.' },
  { c:'Telefonos', cmd:'*P9', m:'Display telefonos.' },

  // ============ EMAIL ============
  { c:'Email', cmd:'PE¥PAX@EMAIL.COM', m:'Agrega email.' },
  { c:'Email', cmd:'PE¥PAX@EMAIL.COM/JUAN PEREZ', m:'Email con nombre.' },
  { c:'Email', cmd:'PE¤1', m:'Borra email linea 1.' },
  { c:'Email', cmd:'*PE', m:'Display emails.' },

  // ============ DIRECCION ============
  { c:'Direccion', cmd:'W-AV CORRIENTES 1234 BUENOS AIRES AR', m:'Direccion del pax (obligatoria ER en muchas PCC).' },
  { c:'Direccion', cmd:'W*BUENOS AIRES Z/1414Z/AR', m:'Direccion con CP y pais.' },
  { c:'Direccion', cmd:'W¤', m:'Borra direccion.' },
  { c:'Direccion', cmd:'*W', m:'Display direccion.' },

  // ============ TICKETING ============
  { c:'Ticketing', cmd:'7TAW/', m:'Ticketing today (TAW).' },
  { c:'Ticketing', cmd:'7TAW15DEC/', m:'Ticketing fecha futura.' },
  { c:'Ticketing', cmd:'7TAW/AGT', m:'Ticketing con queue agent.' },
  { c:'Ticketing', cmd:'7T-A', m:'Ticketed automatic.' },
  { c:'Ticketing', cmd:'7T-', m:'Borra ticketing.' },
  { c:'Ticketing', cmd:'WETR', m:'Emite ticket electronico.' },
  { c:'Ticketing', cmd:'WETK', m:'Emite con form of payment.' },
  { c:'Ticketing', cmd:'W*CCAX370000000000000EXP1226', m:'Forma de pago credit card.' },
  { c:'Ticketing', cmd:'W*CHQ', m:'FOP cheque.' },
  { c:'Ticketing', cmd:'W*CASH', m:'FOP efectivo.' },
  { c:'Ticketing', cmd:'WV*TKT123456789012', m:'Void de ticket.' },
  { c:'Ticketing', cmd:'WFR*', m:'Refund full.' },
  { c:'Ticketing', cmd:'WFR/PR', m:'Refund parcial.' },
  { c:'Ticketing', cmd:'*T', m:'Display ticketing del PNR.' },

  // ============ REMARKS ============
  { c:'Remarks', cmd:'5TEXTO DEL REMARK', m:'Remark general (5).' },
  { c:'Remarks', cmd:'5¥TEXTO VISIBLE AL PAX', m:'Itinerary remark (5¥).' },
  { c:'Remarks', cmd:'5¥S2TEXTO POR SEGMENTO', m:'Itinerary remark segmento 2.' },
  { c:'Remarks', cmd:'5H-AUTORIZADO POR X', m:'Historical remark.' },
  { c:'Remarks', cmd:'5-FOP CASH', m:'Operative remark (pago).' },
  { c:'Remarks', cmd:'5*TKT REMARK', m:'Ticket/print remark.' },
  { c:'Remarks', cmd:'5/2NUEVO TEXTO', m:'Modifica remark linea 2.' },
  { c:'Remarks', cmd:'5¤3', m:'Borra remark linea 3.' },
  { c:'Remarks', cmd:'*P5', m:'Display remarks.' },

  // ============ SSR / OSI ============
  { c:'SSR/OSI', cmd:'3OSI AA CTC PAX 1199', m:'OSI info a la aerolinea.' },
  { c:'SSR/OSI', cmd:'3OSIYY VIP MEMBER', m:'OSI a todas las aerolineas (YY).' },
  { c:'SSR/OSI', cmd:'3WCHR/AA', m:'SSR silla de ruedas (camina).' },
  { c:'SSR/OSI', cmd:'3WCHS/AA', m:'SSR silla escaleras.' },
  { c:'SSR/OSI', cmd:'3WCHC/AA', m:'SSR silla no camina.' },
  { c:'SSR/OSI', cmd:'3VGML/AA', m:'SSR comida vegetariana.' },
  { c:'SSR/OSI', cmd:'3KSML/AA', m:'SSR comida kosher.' },
  { c:'SSR/OSI', cmd:'3MOML/AA', m:'SSR comida musulmana.' },
  { c:'SSR/OSI', cmd:'3DBML/AA', m:'SSR comida diabetica.' },
  { c:'SSR/OSI', cmd:'3CHML/AA', m:'SSR comida nino.' },
  { c:'SSR/OSI', cmd:'3BBML/AA', m:'SSR comida bebe.' },
  { c:'SSR/OSI', cmd:'3BLND/AA', m:'SSR pax ciego.' },
  { c:'SSR/OSI', cmd:'3DEAF/AA', m:'SSR pax sordo.' },
  { c:'SSR/OSI', cmd:'3UMNR/AA08', m:'SSR menor no acompanado (edad).' },
  { c:'SSR/OSI', cmd:'3INFT/AA/PEREZ MARIA/29MAY24-1.1', m:'SSR infante asociado.' },
  { c:'SSR/OSI', cmd:'3DOCS/AA/HK1/P/ARG/AB123456/ARG/15FEB90/M/15DEC30/PEREZ/JUAN', m:'SSR DOCS (pasaporte APIS).' },
  { c:'SSR/OSI', cmd:'3DOCO/AA/HK1/P/AB123456/ARG/15DEC30', m:'SSR visa info.' },
  { c:'SSR/OSI', cmd:'3DOCA/AA/HK1/D/AR/123 CALLE/BUE/Z/1414', m:'SSR direccion APIS.' },

  // ============ FREQUENT FLYER ============
  { c:'Frequent Flyer', cmd:'FFAA1234567890-1.1', m:'FF aerolinea AA pax 1.1.' },
  { c:'Frequent Flyer', cmd:'FF1*', m:'Display FF.' },
  { c:'Frequent Flyer', cmd:'FF¤1', m:'Borra FF linea 1.' },

  // ============ ASIENTOS ============
  { c:'Asientos', cmd:'4G1*', m:'Mapa asientos segmento 1.' },
  { c:'Asientos', cmd:'4G1/15A', m:'Asienta 15A en seg 1.' },
  { c:'Asientos', cmd:'4G1/15A,B,C', m:'Asienta 3 asientos.' },
  { c:'Asientos', cmd:'4G1/NS', m:'No-Smoking preference.' },
  { c:'Asientos', cmd:'4G1/W', m:'Window preference.' },
  { c:'Asientos', cmd:'4G1/A', m:'Aisle preference.' },
  { c:'Asientos', cmd:'4WS', m:'Pre-reserved seat list.' },
  { c:'Asientos', cmd:'4¤G1/15A', m:'Cambia asiento.' },
  { c:'Asientos', cmd:'4X1/15A', m:'Borra asiento.' },

  // ============ CANCELAR ============
  { c:'Cancelar', cmd:'X1', m:'Cancela segmento 1.' },
  { c:'Cancelar', cmd:'X1/3', m:'Cancela segmentos 1 a 3.' },
  { c:'Cancelar', cmd:'XI', m:'Cancela todo el itinerario.' },
  { c:'Cancelar', cmd:'XN', m:'Cancela todo el PNR (limpia).' },
  { c:'Cancelar', cmd:'X-2.1', m:'Borra pasajero 2.1.' },

  // ============ TARIFAS / PRICING ============
  { c:'Tarifas', cmd:'WP', m:'Pricing del itinerario.' },
  { c:'Tarifas', cmd:'WPNI', m:'Bargain Finder Plus.' },
  { c:'Tarifas', cmd:'WPNCS', m:'Pricing No Save.' },
  { c:'Tarifas', cmd:'WPAC', m:'Pricing all carriers (alternate).' },
  { c:'Tarifas', cmd:'WPRQ', m:'Stored fare request.' },
  { c:'Tarifas', cmd:'WC*', m:'Convert fare.' },
  { c:'Tarifas', cmd:'WPRD', m:'Re-display stored fare.' },
  { c:'Tarifas', cmd:'WPNC', m:'No Comb fares.' },
  { c:'Tarifas', cmd:'WPP-ADT/INF', m:'Pricing con tipos de pax.' },
  { c:'Tarifas', cmd:'FD15DECBUEMIA', m:'Fare display.' },
  { c:'Tarifas', cmd:'FD15DECBUEMIA/AA', m:'Fare display por aerolinea.' },
  { c:'Tarifas', cmd:'FQ', m:'Fare quote display.' },
  { c:'Tarifas', cmd:'FQH', m:'Fare quote historico.' },
  { c:'Tarifas', cmd:'FQR', m:'Fare quote rules.' },

  // ============ STORAGE / TRANSACTION ============
  { c:'Storage', cmd:'E', m:'End transaction (guarda PNR).' },
  { c:'Storage', cmd:'ER', m:'End and Retrieve.' },
  { c:'Storage', cmd:'ET', m:'End and Try (debug).' },
  { c:'Storage', cmd:'I', m:'Ignore (descarta cambios).' },
  { c:'Storage', cmd:'IR', m:'Ignore and Retrieve.' },
  { c:'Storage', cmd:'6PAX', m:'Received from (obligatorio antes de ER).' },
  { c:'Storage', cmd:'6AGENT', m:'Received from agent.' },

  // ============ DISPLAY PNR ============
  { c:'PNR', cmd:'*A', m:'Display itinerario aereo.' },
  { c:'PNR', cmd:'*I', m:'Display itinerario completo.' },
  { c:'PNR', cmd:'*N', m:'Nombres.' },
  { c:'PNR', cmd:'*P', m:'Campos pasajero (tel, email, dir).' },
  { c:'PNR', cmd:'*P9', m:'Solo telefonos.' },
  { c:'PNR', cmd:'*PE', m:'Solo emails.' },
  { c:'PNR', cmd:'*P5', m:'Solo remarks.' },
  { c:'PNR', cmd:'*P3', m:'Solo SSR/OSI.' },
  { c:'PNR', cmd:'*T', m:'Ticketing.' },
  { c:'PNR', cmd:'*W', m:'Direccion.' },
  { c:'PNR', cmd:'*HTL', m:'Solo segmentos hotel.' },
  { c:'PNR', cmd:'*CAR', m:'Solo segmentos auto.' },
  { c:'PNR', cmd:'*H', m:'Historial del PNR.' },
  { c:'PNR', cmd:'*HA', m:'Historial detallado.' },
  { c:'PNR', cmd:'*R', m:'PNR completo.' },
  { c:'PNR', cmd:'*ALL', m:'TODO el PNR (todos los campos).' },
  { c:'PNR', cmd:'*-PEREZ', m:'Buscar PNR por apellido.' },
  { c:'PNR', cmd:'*-PEREZ/JUAN', m:'Buscar por nombre completo.' },
  { c:'PNR', cmd:'*ABCDEF', m:'Recuperar por record locator.' },
  { c:'PNR', cmd:'*ABCDEF/PEREZ', m:'Recuperar con validacion.' },
  { c:'PNR', cmd:'*PDK', m:'Display DK info.' },
  { c:'PNR', cmd:'*PQ', m:'Display priced quotes.' },
  { c:'PNR', cmd:'*SVC', m:'Display service requests.' },

  // ============ QUEUES ============
  { c:'Queues', cmd:'QC/100', m:'Lista queue 100.' },
  { c:'Queues', cmd:'QP/100', m:'Coloca PNR en queue 100.' },
  { c:'Queues', cmd:'QP/100/AGT', m:'Queue a agente especifico.' },
  { c:'Queues', cmd:'Q/100', m:'Acceder a la queue 100.' },
  { c:'Queues', cmd:'Q/100/EX/EX', m:'Acceder a sub-queue ex/ex.' },
  { c:'Queues', cmd:'QM', m:'Mensaje en la queue.' },
  { c:'Queues', cmd:'QR', m:'Siguiente PNR de la queue.' },
  { c:'Queues', cmd:'QL', m:'Lista mis queues.' },
  { c:'Queues', cmd:'QSI', m:'Sign in queue.' },
  { c:'Queues', cmd:'QSO', m:'Sign out queue.' },
  { c:'Queues', cmd:'QE', m:'End queue work.' },
  { c:'Queues', cmd:'QT', m:'Throw back PNR a queue.' },
  { c:'Queues', cmd:'QX', m:'Remove PNR de queue.' },
  { c:'Queues', cmd:'QPCN/QXY/100', m:'Queue place con PCC + categoria.' },
  { c:'Queues', cmd:'QC/100/EX/EX', m:'Count PNRs en subqueue.' },

  // ============ DIRECT ACCESS / SCHEDULES ============
  { c:'Direct Access', cmd:'1¥AA', m:'Direct Access a AA inventory.' },
  { c:'Direct Access', cmd:'1¥AA15DECBUEMIA', m:'DA con OD.' },
  { c:'Direct Access', cmd:'WP¥AA', m:'Pricing con DA fare files.' },

  // ============ PROFILE / CUSTOMER ============
  { c:'Profile', cmd:'*QP*PEREZJUAN', m:'Buscar profile por nombre.' },
  { c:'Profile', cmd:'PSM-PEREZJUAN', m:'Move profile al PNR.' },
  { c:'Profile', cmd:'PSL*', m:'Lista profiles.' },

  // ============ MANEJO DE ESTATUS ============
  { c:'Estatus', cmd:'.1H1', m:'Cambia estatus segmento 1 a HK.' },
  { c:'Estatus', cmd:'.1NN', m:'Re-request segmento.' },
  { c:'Estatus', cmd:'.1HK', m:'Confirma segmento.' },
  { c:'Estatus', cmd:'.1¤TK', m:'Modifica a TK status.' },

  // ============ SPLIT / REINSTATE ============
  { c:'Split', cmd:'D2.1', m:'Divide pax 2.1 a nuevo PNR.' },
  { c:'Split', cmd:'F', m:'Finaliza split.' },
  { c:'Split', cmd:'EF', m:'End and finish split.' },
  { c:'Split', cmd:'P', m:'Re-une PNRs (parent).' },

  // ============ REFUND / VOID ============
  { c:'Refund', cmd:'WFR*1', m:'Refund linea 1.' },
  { c:'Refund', cmd:'WFR/PR', m:'Partial refund.' },
  { c:'Refund', cmd:'WFRD', m:'Display refund.' },
  { c:'Refund', cmd:'WV*TKT1234567890123', m:'Void ticket.' },
  { c:'Refund', cmd:'WV*1', m:'Void desde itinerario.' },

  // ============ INFORMACION / HELP ============
  { c:'Info', cmd:'HELP', m:'Help menu.' },
  { c:'Info', cmd:'TKT*', m:'Display ticket info.' },
  { c:'Info', cmd:'TI*', m:'Time table info.' },
  { c:'Info', cmd:'TN*BUE', m:'Tiempo en BUE.' },
  { c:'Info', cmd:'CY*BUE', m:'Currency en BUE.' },
  { c:'Info', cmd:'VISA*ARG', m:'Visa info ARG.' },
  { c:'Info', cmd:'HEALTH*BUEMIA', m:'Health requirements.' },

  // ============ REPORTES Y DK ============
  { c:'Reportes', cmd:'DKAN15DEC', m:'DK net report.' },
  { c:'Reportes', cmd:'DKQR15DEC', m:'DK queue report.' },
  { c:'Reportes', cmd:'DK¤', m:'Borra DK.' },

  // ============ OPERACIONALES ============
  { c:'Operacionales', cmd:'*PDK', m:'Display DK actual.' },
  { c:'Operacionales', cmd:'NF', m:'Numero de file.' },
  { c:'Operacionales', cmd:'NF*', m:'Display NF.' },
  { c:'Operacionales', cmd:'WS*', m:'Display waitlists.' },
];

const TEMPLATES = [
  { id:'air-avail', title:'Disponibilidad aerea', desc:'Display de vuelos.',
    template:'1{DATE}{ORIGIN}{DEST}{TIME}',
    fields:[
      {id:'DATE',label:'Fecha',placeholder:'15JUL',required:true,max:5},
      {id:'ORIGIN',label:'Origen',placeholder:'EZE',required:true,max:3},
      {id:'DEST',label:'Destino',placeholder:'MIA',required:true,max:3},
      {id:'TIME',label:'Hora',placeholder:'8A',required:false,max:4}]},
  { id:'sell-air', title:'Venta aerea', desc:'Vende N asientos.',
    template:'0{COUNT}{CLASS}{LINE}',
    fields:[
      {id:'COUNT',label:'Cantidad',placeholder:'1',required:true,max:1},
      {id:'CLASS',label:'Clase',placeholder:'Y',required:true,max:2},
      {id:'LINE',label:'Linea',placeholder:'1',required:true,max:2}]},
  { id:'pax', title:'Agregar pasajero', desc:'Apellido/Nombre.',
    template:'-{LASTNAME}/{FIRSTNAME}',
    fields:[
      {id:'LASTNAME',label:'Apellido',required:true,max:25},
      {id:'FIRSTNAME',label:'Nombre',required:true,max:25}]},
  { id:'phone', title:'Telefono', desc:'Con tipo (B/H).',
    template:'9{PHONE}-{TYPE}',
    fields:[
      {id:'PHONE',label:'Telefono',required:true,max:30},
      {id:'TYPE',label:'Tipo (B/H)',placeholder:'B',required:true,max:1}]},
  { id:'taw', title:'Ticketing TAW', desc:'Fecha emision.',
    template:'7TAW{DATE}/',
    fields:[{id:'DATE',label:'Fecha',placeholder:'15MAR',required:true,max:5}]},
  { id:'received', title:'Received From', desc:'Recibido de.',
    template:'6{NAME}',
    fields:[{id:'NAME',label:'Nombre',required:true,max:30}]},
  { id:'remark', title:'Remark general', desc:'Comando 5.',
    template:'5{TEXT}', fields:[{id:'TEXT',label:'Texto',required:true,max:200}]},
  { id:'cancel-seg', title:'Cancelar segmento', desc:'X.',
    template:'X{LINE}', fields:[{id:'LINE',label:'Numero',required:true,max:2}]},
  { id:'er', title:'End & retrieve', desc:'ER.', template:'ER', fields:[]},
];

const SAMPLE_SST = `;VERSION:    Sample para Boston Scripts
;PURPOSE:    Quality Control basico
DEFINE [LNAME=ALPHA:25:MAND:::Apellido]
DEFINE [FNAME=ALPHA:25:MAND:::Nombre]
DEFINE [PHONE=A/N:20:MAND:::Telefono]
DEFINE [TYPE=ALPHA:1:MAND:::B o H]
DEFINE [AGENT=A/N:6:MAND:::Sine]

WINDOW H="Datos del pasajero"
    Apellido: [LNAME]
    Nombre:   [FNAME]
ENDWINDOW

»-[LNAME]/[FNAME]{ENTER}«

WINDOW H="Telefono"
    Numero:   [PHONE]
    Tipo:     [TYPE]
ENDWINDOW

»9[PHONE]-[TYPE]{ENTER}«

IF [TYPE] = "B" THEN
    »5BUSINESS PHONE{ENTER}«
ELSE
    »5HOME PHONE{ENTER}«
ENDIF

MENU H="Que mas?"
    "Agregar Frequent Flyer"
        »FFAA123456-1.1{ENTER}«
    "Solo cerrar"
ENDMENU

»6[AGENT]{ENTER}«
»ER{ENTER}«
EXIT
`;

const API_TABS = [
  { id:'fullres', label:'✈️🏨🚗 Crear reserva (vuelo + hotel + auto)' },
  { id:'pnr',     label:'🔍 Recuperar PNR' },
];

const SABRE_CMD_CATALOG = [
  {
    section: '✈️ 1. Vuelos (AIR)',
    color: '#0ea5e9',
    cmds: [
      { tpl:'1<fecha><orig><dest>',           ex:'115DECBUEMIA',           desc:'Disponibilidad de vuelos' },
      { tpl:'1*',                              ex:'1*',                     desc:'Siguiente pantalla de disponibilidad' },
      { tpl:'1R<fecha>',                       ex:'1R15DEC',                desc:'Disponibilidad de retorno' },
      { tpl:'01<clase>1',                      ex:'01Y1',                   desc:'Vender 1 asiento clase Y del primer vuelo listado' },
      { tpl:'0<airline><nro><cls><fecha><o><d>NN1', ex:'0AA123Y15DECBUEMIANN1', desc:'Long sell directo (sin disponibilidad)' },
      { tpl:'WP',                              ex:'WP',                     desc:'Pricing/cotizar itinerario' },
      { tpl:'WPNI',                            ex:'WPNI',                   desc:'Pricing con Bargain Finder Plus' },
    ]
  },
  {
    section: '🏨 2. Hoteles (HOTEL)',
    color: '#a855f7',
    cmds: [
      { tpl:'HOT<in>-<out><city>',             ex:'HOT15DEC-18DECMIA',      desc:'Disponibilidad de hoteles' },
      { tpl:'HOT<in>-<out>/<city>/CC-<cadena>', ex:'HOT15DEC-18DEC/MIA/CC-HI', desc:'Disponibilidad por cadena (Holiday Inn)' },
      { tpl:'HRG<line>',                       ex:'HRG1',                   desc:'Detalle/reglas del hotel en linea N' },
      { tpl:'HRD<line>',                       ex:'HRD1',                   desc:'Descripcion del hotel en linea N' },
      { tpl:'0HHL<chain>GK1<city><in>-<out>/<roomtype>/G-<garantia>', ex:'0HHLHIGK1MIA15DEC-18DEC/DBLB/G-AX370000000000000EXP1226', desc:'Venta de hotel pasivo' },
      { tpl:'HS1/SI-<preferencias>',           ex:'HS1/SI-LATE CHECK IN',   desc:'Special Instructions al hotel' },
    ]
  },
  {
    section: '🚗 3. Autos (CAR)',
    color: '#f59e0b',
    cmds: [
      { tpl:'CF<pickup>-<return><city>',       ex:'CF15DEC-18DECMIA',       desc:'Disponibilidad de autos' },
      { tpl:'CQ<line>',                        ex:'CQ1',                    desc:'Cotizacion del auto en linea N' },
      { tpl:'0CCR<vendor>GK1<city><in>-<out>/<cat>', ex:'0CCRZIGK1MIA15DEC-18DEC/ECAR', desc:'Venta directa de auto (Avis ZI)' },
      { tpl:'CC<line>/RC-<conf>',              ex:'CC1/RC-12345ABC',        desc:'Agregar nro de confirmacion al auto' },
    ]
  },
  {
    section: '📋 4. Datos PNR (5 elementos basicos P-R-I-N-T)',
    color: '#22d989',
    cmds: [
      { tpl:'-<APELLIDO>/<NOMBRE><TITULO>',    ex:'-PEREZ/JUANMR',          desc:'Nombre del pasajero' },
      { tpl:'9<ciudad><tel>-<tipo>',           ex:'9BUE4555-1234-A',        desc:'Telefono (A=agencia, B=business, H=home)' },
      { tpl:'6<received>',                     ex:'6PAX',                   desc:'Received from (auditoria)' },
      { tpl:'7TAW/',                           ex:'7TAW/',                  desc:'Ticketing arrangement (TAW pendiente)' },
      { tpl:'7TAW<fecha>/',                    ex:'7TAW15DEC/',             desc:'Ticketing con deadline' },
      { tpl:'3OSI<airline> <texto>',           ex:'3OSI AA CTC PAX 1199',   desc:'OSI - info a la aerolinea' },
      { tpl:'3<codigo>/<airline> <texto>',     ex:'3VGML/AA',               desc:'SSR - meal/wheelchair/etc' },
      { tpl:'5<texto>',                        ex:'5BOOKED VIA BOSTON',     desc:'Remark general' },
    ]
  },
  {
    section: '💾 5. Guardar y mostrar PNR',
    color: '#16a34a',
    cmds: [
      { tpl:'E',                               ex:'E',                      desc:'End transaction (guarda y genera locator)' },
      { tpl:'ER',                              ex:'ER',                     desc:'End and Retrieve (guarda + redisplay)' },
      { tpl:'I',                               ex:'I',                      desc:'Ignore (descarta cambios)' },
      { tpl:'*R',                              ex:'*R',                     desc:'Mostrar PNR completo' },
      { tpl:'*A',                              ex:'*A',                     desc:'Mostrar solo itinerario aereo' },
      { tpl:'*HTL',                            ex:'*HTL',                   desc:'Solo segmentos hotel' },
      { tpl:'*CAR',                            ex:'*CAR',                   desc:'Solo segmentos auto' },
      { tpl:'*N',                              ex:'*N',                     desc:'Nombres' },
      { tpl:'*P',                              ex:'*P',                     desc:'Campos de pasajero (telefonos, emails)' },
      { tpl:'*T',                              ex:'*T',                     desc:'Ticketing' },
      { tpl:'*H',                              ex:'*H',                     desc:'Historial del PNR' },
      { tpl:'*ALL',                            ex:'*ALL',                   desc:'TODO el PNR' },
    ]
  },
  {
    section: '🔍 6. Recuperar PNR existente',
    color: '#0891b2',
    cmds: [
      { tpl:'*<locator>',                      ex:'*ABCDEF',                desc:'Recuperar PNR por record locator' },
      { tpl:'*-<APELLIDO>',                    ex:'*-PEREZ',                desc:'Buscar PNR por apellido' },
      { tpl:'*-<APELLIDO>/<NOMBRE>',           ex:'*-PEREZ/JUAN',           desc:'Recuperar por nombre completo' },
      { tpl:'*<locator>/<APELLIDO>',           ex:'*ABCDEF/PEREZ',          desc:'Recuperar con validacion de apellido' },
    ]
  },
];

const FIELD_TYPES = [
  { id:'text',     label:'Texto'      },
  { id:'textarea', label:'Texto largo'},
  { id:'number',   label:'Numero'     },
  { id:'date',     label:'Fecha'      },
  { id:'select',   label:'Lista (select)' },
  { id:'checkbox', label:'Checkbox'   },
];

const REMARK_TYPES = [
  { id:'',           label:'Comando directo (PE u otro)' },
  { id:'General',    label:'General (5)' },
  { id:'Itinerary',  label:'Itinerary (5.)' },
  { id:'Historical', label:'Historical (5H-)' },
  { id:'Invoice',    label:'Invoice (5-)' },
  { id:'Ticket',     label:'Ticket (5*)' },
  { id:'Phone',      label:'Telefono (9-)' },
  { id:'Received',   label:'Recibido de (6)' },
  { id:'Ticketing',  label:'Ticketing (7)' },
  { id:'SSR',        label:'SSR/OSI (3)' },
];

const RECIPES = [
  // ==================== CONSULTA / PNR ====================
  { id:'pnr_display_full', category:'Consulta', title:'Consultar PNR completo', description:'*A, *N, *P, *I — vista total del PNR.',
    apply: () => ({ name:'consultar_pnr_completo', title:'CONSULTAR PNR COMPLETO',
      forms:[{ form:'form1', title:'CONSULTA', title_visible:true, remarks:[] }],
      postCommands:['*A','*N','*P','*I'], validateActiveReservation:true, sendCommands:true }) },
  { id:'pnr_display_history', category:'Consulta', title:'Ver historial del PNR (*H)', description:'Auditoria completa: quien hizo que y cuando.',
    apply: () => ({ name:'historial_pnr', title:'VER HISTORIAL DEL PNR',
      forms:[{ form:'form1', title:'HISTORIAL', title_visible:true, remarks:[] }],
      postCommands:['*A','*H'], validateActiveReservation:true, sendCommands:true }) },
  { id:'pnr_retrieve_by_locator', category:'Consulta', title:'Recuperar PNR por record locator', description:'Abre un PNR especifico desde el record locator.',
    apply: () => ({ name:'recuperar_pnr', title:'RECUPERAR PNR',
      forms:[{ form:'form1', title:'PNR A RECUPERAR', title_visible:true, remarks:[
        mkField({ label:'Record locator (6 chars)', mandatory:true })
      ]}], postCommands:['*{{field_0}}','*A'], validateActiveReservation:false, sendCommands:true }) },
  { id:'pnr_retrieve_by_name', category:'Consulta', title:'Buscar PNR por apellido', description:'*-APELLIDO para encontrar PNRs del pasajero.',
    apply: () => ({ name:'buscar_pnr_apellido', title:'BUSCAR PNR POR APELLIDO',
      forms:[{ form:'form1', title:'BUSQUEDA', title_visible:true, remarks:[
        mkField({ label:'Apellido', mandatory:true })
      ]}], postCommands:['*-{{field_0}}'], validateActiveReservation:false, sendCommands:true }) },

  // ==================== REMARKS ====================
  { id:'remark_general', category:'Remarks', title:'Remark general (5)', description:'Nota interna corta en el PNR.',
    apply: () => ({ name:'remark_general', title:'AGREGAR REMARK GENERAL',
      forms:[{ form:'form1', title:'REMARK', title_visible:true, remarks:[
        mkField({ label:'Texto del remark', remark_mask:'', typeremark:'General', mandatory:true })
      ]}], postCommands:['ER'], validateActiveReservation:true }) },
  { id:'remark_itinerary', category:'Remarks', title:'Itinerary remark (5¥) — visible al pax', description:'Mensaje VISIBLE al pasajero en su itinerario.',
    apply: () => ({ name:'remark_itinerary', title:'ITINERARY REMARK',
      forms:[{ form:'form1', title:'ITINERARIO', title_visible:true, remarks:[
        mkField({ label:'Texto visible al pasajero', remark_mask:'¥', typeremark:'Itinerary', mandatory:true })
      ]}], postCommands:['ER'], validateActiveReservation:true }) },
  { id:'remark_itinerary_segment', category:'Remarks', title:'Itinerary remark por segmento (5¥S#)', description:'Nota visible al pax atada a un segmento concreto.',
    apply: () => ({ name:'remark_itinerary_seg', title:'ITINERARY REMARK POR SEGMENTO',
      forms:[{ form:'form1', title:'POR SEGMENTO', title_visible:true, remarks:[
        mkField({ label:'Numero de segmento', remark_mask:'¥S', typeremark:'Itinerary', mandatory:true }),
        mkField({ label:'Texto', remark_mask:' ', typeremark:'Itinerary', mandatory:true })
      ]}], postCommands:['ER'], validateActiveReservation:true }) },
  { id:'remark_historical', category:'Remarks', title:'Historical remark (5H-)', description:'Auditoria, autorizaciones, decisiones.',
    apply: () => ({ name:'remark_historical', title:'HISTORICAL REMARK',
      forms:[{ form:'form1', title:'HISTORICO', title_visible:true, remarks:[
        mkField({ label:'Texto del historico', remark_mask:'H-', typeremark:'Historical', mandatory:true })
      ]}], postCommands:['ER','*H'], validateActiveReservation:true }) },
  { id:'remark_bulk_3', category:'Remarks', title:'Agregar 3 remarks de una vez ⚡', description:'Tres remarks distintos en una sola pasada (frecuente en QC).',
    apply: () => ({ name:'remarks_bulk_3', title:'AGREGAR 3 REMARKS',
      forms:[{ form:'form1', title:'TRES REMARKS', title_visible:true, remarks:[
        mkField({ label:'Remark #1', remark_mask:'', mandatory:true }),
        mkField({ label:'Remark #2', remark_mask:'', mandatory:true }),
        mkField({ label:'Remark #3', remark_mask:'', mandatory:false })
      ]}], postCommands:['*A','ER'], validateActiveReservation:true }) },
  { id:'remark_bulk_5', category:'Remarks', title:'Agregar 5 remarks de una vez ⚡', description:'Cinco remarks numerados — caso operativo típico.',
    apply: () => ({ name:'remarks_bulk_5', title:'AGREGAR 5 REMARKS',
      forms:[{ form:'form1', title:'CINCO REMARKS', title_visible:true, remarks:[
        mkField({ label:'Remark #1', remark_mask:'', mandatory:true }),
        mkField({ label:'Remark #2', remark_mask:'', mandatory:true }),
        mkField({ label:'Remark #3', remark_mask:'', mandatory:false }),
        mkField({ label:'Remark #4', remark_mask:'', mandatory:false }),
        mkField({ label:'Remark #5', remark_mask:'', mandatory:false })
      ]}], postCommands:['*A','ER'], validateActiveReservation:true }) },
  { id:'remark_modify', category:'Remarks', title:'Modificar remark existente', description:'Reemplazar el texto de una linea de remark.',
    apply: () => ({ name:'modificar_remark', title:'MODIFICAR REMARK',
      forms:[{ form:'form1', title:'MODIFICAR', title_visible:true, remarks:[
        mkField({ label:'Numero de linea', mandatory:true }),
        mkField({ label:'Nuevo texto', remark_mask:'¤', mandatory:true })
      ]}], postCommands:['ER'], validateActiveReservation:true }) },
  { id:'remark_delete', category:'Remarks', title:'Eliminar remark por linea', description:'Borra una linea de remark del PNR.',
    apply: () => ({ name:'eliminar_remark', title:'ELIMINAR REMARK',
      forms:[{ form:'form1', title:'ELIMINAR', title_visible:true, remarks:[
        mkField({ label:'Numero de linea', remark_mask:'¤', mandatory:true })
      ]}], postCommands:['ER'], validateActiveReservation:true }) },
  { id:'remark_ssr', category:'Remarks', title:'SSR (Special Service Request)', description:'Servicios especiales: silla, comida, infante.',
    apply: () => ({ name:'ssr_request', title:'AGREGAR SSR',
      forms:[{ form:'form1', title:'SSR', title_visible:true, remarks:[
        mkField({ label:'Codigo SSR', typedata:'select', mandatory:true, datasource:[
          {value:'WCHR',text:'WCHR - Silla de ruedas (puede caminar)'},
          {value:'WCHC',text:'WCHC - Silla de ruedas (no camina)'},
          {value:'VGML',text:'VGML - Comida vegetariana'},
          {value:'KSML',text:'KSML - Comida kosher'},
          {value:'MOML',text:'MOML - Comida musulmana'},
          {value:'DBML',text:'DBML - Comida diabetica'},
          {value:'BLND',text:'BLND - Pax discapacidad visual'},
          {value:'DEAF',text:'DEAF - Pax sordo'},
          {value:'UMNR',text:'UMNR - Menor no acompañado'},
          {value:'INFT',text:'INFT - Infante en falda'}
        ]}),
        mkField({ label:'Texto del SSR', remark_mask:' ', mandatory:true }),
        mkField({ label:'Aerolinea (2 chars)', mandatory:true })
      ]}], postCommands:['ER'], validateActiveReservation:true }) },
  { id:'remark_osi', category:'Remarks', title:'OSI Message (Other Service Info)', description:'Mensaje informativo a la aerolinea.',
    apply: () => ({ name:'osi_message', title:'AGREGAR OSI',
      forms:[{ form:'form1', title:'OSI', title_visible:true, remarks:[
        mkField({ label:'Aerolinea (2 chars)', remark_mask:'3OSI ', mandatory:true }),
        mkField({ label:'Texto del OSI', remark_mask:' ', mandatory:true })
      ]}], postCommands:['ER'], validateActiveReservation:true }) },
  { id:'remark_pago', category:'Remarks', title:'Remark de forma de pago (5-)', description:'Forma o estado de pago. Sin tarjeta completa ni CVV.',
    apply: () => ({ name:'remark_pago', title:'REMARK FORMA DE PAGO',
      forms:[{ form:'form1', title:'PAGO', title_visible:true, remarks:[
        mkField({ label:'Forma de pago', remark_mask:'-', typedata:'select', typeremark:'General', mandatory:true, datasource:[
          {value:'CASH',text:'CASH'},
          {value:'TRANSFERENCIA',text:'TRANSFERENCIA'},
          {value:'TARJETA VISA',text:'TARJETA VISA'},
          {value:'TARJETA MASTER',text:'TARJETA MASTER'},
          {value:'TARJETA AMEX',text:'TARJETA AMEX'},
          {value:'PAGO PENDIENTE',text:'PAGO PENDIENTE'},
          {value:'BNPL',text:'BOOK NOW PAY LATER'}
        ]})
      ]}], postCommands:['ER'], validateActiveReservation:true }) },

  // ==================== VUELOS / AIR ====================
  { id:'air_availability', category:'Vuelos', title:'Disponibilidad aerea', description:'Display de vuelos disponibles por fecha y ruta.',
    apply: () => ({ name:'disponibilidad_aerea', title:'DISPONIBILIDAD AEREA',
      forms:[{ form:'form1', title:'BUSQUEDA', title_visible:true, remarks:[
        mkField({ label:'Fecha (DDMMM)', typedata:'date', mandatory:true }),
        mkField({ label:'Origen (3 chars)', mandatory:true }),
        mkField({ label:'Destino (3 chars)', mandatory:true }),
        mkField({ label:'Hora preferida (opcional)', mandatory:false })
      ]}], postCommands:['1{{field_0}}{{field_1}}{{field_2}}{{field_3}}'], validateActiveReservation:false, sendCommands:true }) },
  { id:'air_availability_airline', category:'Vuelos', title:'Disponibilidad filtrada por aerolinea', description:'Solo vuelos de una aerolinea especifica.',
    apply: () => ({ name:'disponibilidad_aerolinea', title:'DISPONIBILIDAD POR AEROLINEA',
      forms:[{ form:'form1', title:'BUSQUEDA', title_visible:true, remarks:[
        mkField({ label:'Fecha (DDMMM)', typedata:'date', mandatory:true }),
        mkField({ label:'Origen', mandatory:true }),
        mkField({ label:'Destino', mandatory:true }),
        mkField({ label:'Aerolinea (2 chars)', mandatory:true })
      ]}], postCommands:['1{{field_0}}{{field_1}}{{field_2}}‡{{field_3}}'], validateActiveReservation:false, sendCommands:true }) },
  { id:'air_direct_access', category:'Vuelos', title:'Direct Access a host de aerolinea', description:'1¥AA - consulta directa al inventario de la aerolinea.',
    apply: () => ({ name:'direct_access', title:'DIRECT ACCESS',
      forms:[{ form:'form1', title:'DA', title_visible:true, remarks:[
        mkField({ label:'Fecha (DDMMM)', typedata:'date', mandatory:true }),
        mkField({ label:'Origen', mandatory:true }),
        mkField({ label:'Destino', mandatory:true }),
        mkField({ label:'Aerolinea (2 chars)', mandatory:true })
      ]}], postCommands:['1{{field_0}}{{field_1}}{{field_2}}¤{{field_3}}'], validateActiveReservation:false, sendCommands:true }) },
  { id:'air_sell', category:'Vuelos', title:'Venta aerea (sell from availability)', description:'Vende N asientos en la linea Y de la disponibilidad.',
    apply: () => ({ name:'venta_aerea', title:'VENTA AEREA',
      forms:[{ form:'form1', title:'VENTA', title_visible:true, remarks:[
        mkField({ label:'Cantidad', typedata:'number', mandatory:true }),
        mkField({ label:'Clase (Y/M/L/etc)', mandatory:true }),
        mkField({ label:'Linea de la disponibilidad', mandatory:true })
      ]}], postCommands:['0{{field_0}}{{field_1}}{{field_2}}','*A','ER'], validateActiveReservation:false, sendCommands:true }) },
  { id:'air_long_sell', category:'Vuelos', title:'Long sell — vuelo completo sin disponibilidad', description:'Vende un segmento aereo especificando todos los datos.',
    apply: () => ({ name:'long_sell_aereo', title:'LONG SELL AEREO',
      forms:[{ form:'form1', title:'SEGMENTO', title_visible:true, remarks:[
        mkField({ label:'Aerolinea (2 chars)', mandatory:true }),
        mkField({ label:'Numero de vuelo', mandatory:true }),
        mkField({ label:'Clase', mandatory:true }),
        mkField({ label:'Fecha (DDMMM)', typedata:'date', mandatory:true }),
        mkField({ label:'Origen', mandatory:true }),
        mkField({ label:'Destino', mandatory:true }),
        mkField({ label:'Status (NN1/SS1/GK1)', mandatory:true })
      ]}], postCommands:['0{{field_0}}{{field_1}}{{field_2}}{{field_3}}{{field_4}}{{field_5}}{{field_6}}','*A','ER'], validateActiveReservation:false, sendCommands:true }) },
  { id:'air_passive', category:'Vuelos', title:'Segmento aereo pasivo (GK)', description:'Vuelo informativo no afecta inventario.',
    apply: () => ({ name:'segmento_pasivo', title:'SEGMENTO PASIVO',
      forms:[{ form:'form1', title:'GK', title_visible:true, remarks:[
        mkField({ label:'Aerolinea', mandatory:true }),
        mkField({ label:'Vuelo', mandatory:true }),
        mkField({ label:'Clase', mandatory:true }),
        mkField({ label:'Fecha', typedata:'date', mandatory:true }),
        mkField({ label:'Origen', mandatory:true }),
        mkField({ label:'Destino', mandatory:true })
      ]}], postCommands:['0{{field_0}}{{field_1}}{{field_2}}{{field_3}}{{field_4}}{{field_5}}GK1','*A','ER'], validateActiveReservation:false, sendCommands:true }) },
  { id:'air_cancel_seg', category:'Vuelos', title:'Cancelar segmento aereo', description:'Cancela un segmento por su numero de linea (X1, X2, etc).',
    apply: () => ({ name:'cancelar_segmento', title:'CANCELAR SEGMENTO',
      forms:[{ form:'form1', title:'CANCELAR', title_visible:true, remarks:[
        mkField({ label:'Numero de segmento', mandatory:true })
      ]}], postCommands:['X{{field_0}}','*A','ER'], validateActiveReservation:true, sendCommands:true }) },
  { id:'air_arnk', category:'Vuelos', title:'ARNK / Surface (segmento terrestre)', description:'Agrega gap o surface segment al itinerario.',
    apply: () => ({ name:'arnk_surface', title:'ARNK / SURFACE',
      forms:[{ form:'form1', title:'GAP', title_visible:true, remarks:[] }],
      postCommands:['0A','*A','ER'], validateActiveReservation:true, sendCommands:true }) },
  { id:'air_reprice_bfp', category:'Vuelos', title:'Reprice Bargain Finder Plus (WPNI)', description:'Re-cotiza el PNR buscando la mejor tarifa.',
    apply: () => ({ name:'reprice_bfp', title:'REPRICE BFP',
      forms:[{ form:'form1', title:'REPRICE', title_visible:true, remarks:[] }],
      postCommands:['*A','WPNI','ER'], validateActiveReservation:true, sendCommands:true }) },
  { id:'air_fare_display', category:'Vuelos', title:'Fare Display (consulta tarifa)', description:'Ver tarifas publicadas entre dos ciudades.',
    apply: () => ({ name:'fare_display', title:'FARE DISPLAY',
      forms:[{ form:'form1', title:'TARIFAS', title_visible:true, remarks:[
        mkField({ label:'Fecha', typedata:'date', mandatory:true }),
        mkField({ label:'Origen', mandatory:true }),
        mkField({ label:'Destino', mandatory:true })
      ]}], postCommands:['FD{{field_0}}{{field_1}}{{field_2}}'], validateActiveReservation:false, sendCommands:true }) },
  { id:'air_pricing_menu', category:'Vuelos', title:'Tarifado del PNR (menu WP / WPNC / WPNI / PQ)', description:'Cotiza el PNR activo con el metodo de tarifado elegido.',
    apply: () => ({ name:'tarifado_pnr', title:'TARIFADO DEL PNR',
      forms:[{ form:'form1', title:'METODO DE TARIFADO', title_visible:true, remarks:[
        mkField({ label:'Metodo', typedata:'select', mandatory:true, datasource:[
          {value:'WP',text:'WP - Tarifar como esta reservado'},
          {value:'WPNC',text:'WPNC - Best Buy (rebooking a la mas baja)'},
          {value:'WPNCB',text:'WPNCB - Best Buy con rebooking forzado'},
          {value:'WPNI',text:'WPNI - Bargain Finder Plus (informativo)'},
          {value:'PQ',text:'PQ - Guardar price quote en el PNR'}
        ]})
      ]}], postCommands:['*A','{{field_0}}'], validateActiveReservation:true, sendCommands:true }) },

  // ==================== HOTELES ====================
  { id:'hotel_avail', category:'Hoteles', title:'Disponibilidad de hoteles', description:'Buscar hoteles por ciudad y fechas.',
    apply: () => ({ name:'disponibilidad_hoteles', title:'DISPONIBILIDAD HOTELES',
      forms:[{ form:'form1', title:'BUSQUEDA', title_visible:true, remarks:[
        mkField({ label:'Ciudad (3 chars)', mandatory:true }),
        mkField({ label:'Check-in (DDMMM)', typedata:'date', mandatory:true }),
        mkField({ label:'Check-out (DDMMM)', typedata:'date', mandatory:true })
      ]}], postCommands:['HOT{{field_0}}{{field_1}}-{{field_2}}'], validateActiveReservation:false, sendCommands:true }) },
  { id:'hotel_rates', category:'Hoteles', title:'Detalle de tarifas de hotel (HOD)', description:'Ver tarifas y condiciones de un hotel de la disponibilidad (HOT).',
    apply: () => ({ name:'detalle_tarifas_hotel', title:'DETALLE TARIFAS HOTEL',
      forms:[{ form:'form1', title:'TARIFAS', title_visible:true, remarks:[
        mkField({ label:'Linea de la disponibilidad', typedata:'number', mandatory:true })
      ]}], postCommands:['HOD{{field_0}}'], validateActiveReservation:false, sendCommands:true }) },
  { id:'hotel_sell', category:'Hoteles', title:'Venta de hotel desde disponibilidad (HS)', description:'Vende una habitacion de la lista (HOT) por su linea / codigo de tarifa.',
    apply: () => ({ name:'venta_hotel', title:'VENTA HOTEL',
      forms:[{ form:'form1', title:'VENTA', title_visible:true, remarks:[
        mkField({ label:'Linea de la disponibilidad', typedata:'number', mandatory:true }),
        mkField({ label:'Codigo de tarifa (ej A1K)', mandatory:false }),
        mkField({ label:'Cantidad de habitaciones', typedata:'number', mandatory:false })
      ]}], postCommands:['HS{{field_0}}{{field_1}}{{field_2}}','*A','ER'], validateActiveReservation:true, sendCommands:true }) },
  { id:'hotel_passive', category:'Hoteles', title:'Hotel pasivo (HHL)', description:'Vende hotel como segmento pasivo sin inventario.',
    apply: () => ({ name:'hotel_pasivo', title:'HOTEL PASIVO',
      forms:[{ form:'form1', title:'HOTEL', title_visible:true, remarks:[
        mkField({ label:'Cadena (3 chars)', mandatory:true }),
        mkField({ label:'Codigo hotel', mandatory:true }),
        mkField({ label:'Ciudad', mandatory:true }),
        mkField({ label:'Check-in (DDMMM)', typedata:'date', mandatory:true }),
        mkField({ label:'Check-out (DDMMM)', typedata:'date', mandatory:true }),
        mkField({ label:'Pasajeros', typedata:'number', mandatory:true }),
        mkField({ label:'Tipo de habitacion', mandatory:false })
      ]}], postCommands:['0HHL{{field_0}}HK1{{field_2}}{{field_3}}/D-{{field_4}}/NM-{{field_5}}/H-{{field_1}}','*A','ER'], validateActiveReservation:true, sendCommands:true }) },
  { id:'hotel_confirmation', category:'Hoteles', title:'Remark con confirmacion hotel', description:'Guarda el confirmation number del hotel en el PNR.',
    apply: () => ({ name:'hotel_confirmation', title:'HOTEL CONFIRMATION',
      forms:[{ form:'form1', title:'CONFIRMACION', title_visible:true, remarks:[
        mkField({ label:'Numero de confirmacion', remark_mask:'-HTL CONF: ', mandatory:true }),
        mkField({ label:'Nombre del hotel', remark_mask:' / ', mandatory:true })
      ]}], postCommands:['ER'], validateActiveReservation:true }) },

  // ==================== AUTOS ====================
  { id:'car_avail', category:'Autos', title:'Disponibilidad de autos', description:'Buscar autos por aeropuerto/ciudad y fechas.',
    apply: () => ({ name:'disponibilidad_autos', title:'DISPONIBILIDAD AUTOS',
      forms:[{ form:'form1', title:'BUSQUEDA', title_visible:true, remarks:[
        mkField({ label:'Aeropuerto/ciudad', mandatory:true }),
        mkField({ label:'Fecha pickup', typedata:'date', mandatory:true }),
        mkField({ label:'Fecha return', typedata:'date', mandatory:true }),
        mkField({ label:'Hora pickup (HHMM)', mandatory:true }),
        mkField({ label:'Hora return (HHMM)', mandatory:true }),
        mkField({ label:'Categoria (ICAR/CCAR/etc)', mandatory:false })
      ]}], postCommands:['CF{{field_0}}/{{field_1}}-{{field_2}}/{{field_3}}-{{field_4}}/{{field_5}}'], validateActiveReservation:false, sendCommands:true }) },
  { id:'car_sell', category:'Autos', title:'Venta de auto desde disponibilidad (0C)', description:'Vende un auto de la lista (CF) por su numero de linea.',
    apply: () => ({ name:'venta_auto', title:'VENTA AUTO',
      forms:[{ form:'form1', title:'VENTA', title_visible:true, remarks:[
        mkField({ label:'Linea de la disponibilidad', typedata:'number', mandatory:true })
      ]}], postCommands:['0C{{field_0}}','*A','ER'], validateActiveReservation:true, sendCommands:true }) },
  { id:'car_passive', category:'Autos', title:'Auto pasivo (CK)', description:'Vende auto como segmento pasivo.',
    apply: () => ({ name:'auto_pasivo', title:'AUTO PASIVO',
      forms:[{ form:'form1', title:'AUTO', title_visible:true, remarks:[
        mkField({ label:'Vendor (2 chars)', mandatory:true }),
        mkField({ label:'Ciudad/aeropuerto', mandatory:true }),
        mkField({ label:'Fecha pickup', typedata:'date', mandatory:true }),
        mkField({ label:'Fecha return', typedata:'date', mandatory:true }),
        mkField({ label:'Hora pickup (HHMM)', mandatory:true }),
        mkField({ label:'Hora return (HHMM)', mandatory:true })
      ]}], postCommands:['0CK{{field_0}}1{{field_1}}{{field_2}}-{{field_3}}/{{field_4}}-{{field_5}}','*A','ER'], validateActiveReservation:true, sendCommands:true }) },
  { id:'car_confirmation', category:'Autos', title:'Remark con confirmacion auto', description:'Guarda el confirmation number de la rentadora.',
    apply: () => ({ name:'car_confirmation', title:'CAR CONFIRMATION',
      forms:[{ form:'form1', title:'CONFIRMACION', title_visible:true, remarks:[
        mkField({ label:'Numero de confirmacion', remark_mask:'-CAR CONF: ', mandatory:true }),
        mkField({ label:'Rentadora', remark_mask:' / ', mandatory:true })
      ]}], postCommands:['ER'], validateActiveReservation:true }) },

  // ==================== PASAJEROS ====================
  { id:'pax_add', category:'Pasajeros', title:'Agregar pasajero adulto', description:'Agrega un adulto al PNR.',
    apply: () => ({ name:'agregar_pasajero', title:'AGREGAR PASAJERO',
      forms:[{ form:'form1', title:'NOMBRE', title_visible:true, remarks:[
        mkField({ label:'Apellido', mandatory:true }),
        mkField({ label:'Nombre', remark_mask:'/', mandatory:true }),
        mkField({ label:'Titulo (MR/MRS/MS)', remark_mask:' ', mandatory:true })
      ]}], postCommands:['-{{field_0}}/{{field_1}} {{field_2}}','*N','ER'], validateActiveReservation:true, sendCommands:true }) },
  { id:'pax_infant', category:'Pasajeros', title:'Agregar infante (INF)', description:'Infante menor a 2 años, en falda del adulto.',
    apply: () => ({ name:'agregar_infante', title:'AGREGAR INFANTE',
      forms:[{ form:'form1', title:'INFANTE', title_visible:true, remarks:[
        mkField({ label:'Apellido', mandatory:true }),
        mkField({ label:'Nombre', remark_mask:'/', mandatory:true }),
        mkField({ label:'Fecha nacimiento (DDMMMYY)', remark_mask:'*DOB', mandatory:true }),
        mkField({ label:'Numero adulto (1.1)', mandatory:true })
      ]}], postCommands:['-I/{{field_0}}/{{field_1}} MISS{{field_2}}','3INFT/{{field_0}}/{{field_1}} MISS/13-{{field_3}}','ER'], validateActiveReservation:true, sendCommands:true }) },
  { id:'pax_child', category:'Pasajeros', title:'Agregar niño (CHD)', description:'Niño entre 2-11 años, asiento propio.',
    apply: () => ({ name:'agregar_nino', title:'AGREGAR NIÑO',
      forms:[{ form:'form1', title:'NIÑO', title_visible:true, remarks:[
        mkField({ label:'Apellido', mandatory:true }),
        mkField({ label:'Nombre', remark_mask:'/', mandatory:true }),
        mkField({ label:'Edad', typedata:'number', remark_mask:'*C', mandatory:true })
      ]}], postCommands:['-{{field_0}}/{{field_1}}{{field_2}}','*N','ER'], validateActiveReservation:true, sendCommands:true }) },
  { id:'pax_modify', category:'Pasajeros', title:'Modificar nombre pasajero', description:'Cambia el nombre del pasajero indicado.',
    apply: () => ({ name:'modificar_nombre', title:'MODIFICAR NOMBRE',
      forms:[{ form:'form1', title:'NUEVO NOMBRE', title_visible:true, remarks:[
        mkField({ label:'Numero pasajero (1.1)', mandatory:true }),
        mkField({ label:'Nuevo apellido/nombre', remark_mask:'¤', mandatory:true })
      ]}], postCommands:['-{{field_0}}¤{{field_1}}','*N','ER'], validateActiveReservation:true, sendCommands:true }) },
  { id:'pax_phone', category:'Pasajeros', title:'Agregar telefono', description:'Telefono business o home del pax.',
    apply: () => ({ name:'agregar_telefono', title:'AGREGAR TELEFONO',
      forms:[{ form:'form1', title:'TELEFONO', title_visible:true, remarks:[
        mkField({ label:'Numero', remark_mask:'9', mandatory:true }),
        mkField({ label:'Tipo', remark_mask:'-', typedata:'select', mandatory:true, datasource:[
          {value:'B',text:'Business'},{value:'H',text:'Home'}
        ]})
      ]}], postCommands:['*P','ER'], validateActiveReservation:true, sendCommands:true }) },
  { id:'pax_email', category:'Pasajeros', title:'Agregar email (PE)', description:'Email del pax para TripCase / itinerario.',
    apply: () => ({ name:'agregar_email', title:'AGREGAR EMAIL',
      forms:[{ form:'form1', title:'EMAIL', title_visible:true, remarks:[
        mkField({ label:'Email', remark_mask:'PE¥', mandatory:true })
      ]}], postCommands:['ER'], validateActiveReservation:true }) },
  { id:'pax_freq_flyer', category:'Pasajeros', title:'Frequent Flyer', description:'Numero de programa de viajero frecuente.',
    apply: () => ({ name:'frequent_flyer', title:'FREQUENT FLYER',
      forms:[{ form:'form1', title:'FF', title_visible:true, remarks:[
        mkField({ label:'Aerolinea (2 chars)', remark_mask:'FF', mandatory:true }),
        mkField({ label:'Numero FF', mandatory:true }),
        mkField({ label:'Numero pasajero (1.1)', remark_mask:'-', mandatory:true })
      ]}], postCommands:['*A','ER'], validateActiveReservation:true, sendCommands:true }) },

  // ==================== TICKETING ====================
  { id:'tkt_taw', category:'Ticketing', title:'Ticketing TAW', description:'Define fecha limite de emision.',
    apply: () => ({ name:'ticketing_taw', title:'CONFIGURAR TAW',
      forms:[{ form:'form1', title:'TAW', title_visible:true, remarks:[
        mkField({ label:'Fecha (DDMMM)', remark_mask:'7TAW', typedata:'date', mandatory:true })
      ]}], postCommands:['ER'], validateActiveReservation:true }) },
  { id:'tkt_issue', category:'Ticketing', title:'Emision de ticket (WPN)', description:'Emite el ticket con la tarifa actual.',
    apply: () => ({ name:'emision_ticket', title:'EMITIR TICKET',
      forms:[{ form:'form1', title:'EMISION', title_visible:true, remarks:[
        mkField({ label:'Forma de pago (CASH/CC AX..)', mandatory:true })
      ]}], postCommands:['*A','WP','WPN','6{{field_0}}','ER'], validateActiveReservation:true, sendCommands:true }) },
  { id:'tkt_void', category:'Ticketing', title:'Void de ticket', description:'Anula un ticket emitido (solo el mismo dia).',
    apply: () => ({ name:'void_ticket', title:'VOID TICKET',
      forms:[{ form:'form1', title:'VOID', title_visible:true, remarks:[
        mkField({ label:'Numero de ticket (13 chars)', remark_mask:'WV', mandatory:true })
      ]}], postCommands:['ER'], validateActiveReservation:true, sendCommands:true }) },
  { id:'received_from', category:'Ticketing', title:'Received From (6)', description:'Recibido de — auditoria de quien autorizo.',
    apply: () => ({ name:'received_from', title:'RECEIVED FROM',
      forms:[{ form:'form1', title:'RECEIVED', title_visible:true, remarks:[
        mkField({ label:'Quien autoriza', remark_mask:'6', mandatory:true })
      ]}], postCommands:['ER'], validateActiveReservation:true }) },

  // ==================== QUEUES ====================
  { id:'queue_place', category:'Queues', title:'Enviar PNR a cola', description:'Coloca el PNR en una cola para procesamiento posterior.',
    apply: () => ({ name:'queue_place', title:'ENVIAR A QUEUE',
      forms:[{ form:'form1', title:'QUEUE', title_visible:true, remarks:[
        mkField({ label:'Numero de queue', mandatory:true }),
        mkField({ label:'PCC destino (opcional)', mandatory:false })
      ]}], postCommands:['QP/{{field_0}}/{{field_1}}','ER'], validateActiveReservation:true, sendCommands:true }) },
  { id:'queue_list', category:'Queues', title:'Listar PNRs en queue', description:'Ver el contenido de una cola.',
    apply: () => ({ name:'queue_list', title:'LISTAR QUEUE',
      forms:[{ form:'form1', title:'QUEUE', title_visible:true, remarks:[
        mkField({ label:'Numero de queue', mandatory:true })
      ]}], postCommands:['QC/{{field_0}}'], validateActiveReservation:false, sendCommands:true }) },

  // ==================== OPERACIONALES BASSET ====================
  { id:'op_qc_full', category:'Operacionales', title:'Quality Control completo', description:'Display PNR + remarks + telefonos para revisar antes de emitir.',
    apply: () => ({ name:'quality_control', title:'QUALITY CONTROL',
      forms:[{ form:'form1', title:'QC', title_visible:true, remarks:[
        mkField({ label:'Agente que revisa', remark_mask:'5QC OK - REV BY ', typeremark:'Historical', mandatory:true })
      ]}], postCommands:['*A','*N','*P','*T','ER'], validateActiveReservation:true, sendCommands:true }) },
  { id:'op_rebooking_pcc', category:'Operacionales', title:'Rebooking entre PCCs ⚡', description:'Cambia PCC y reprice del PNR (ej. ARG→URU).',
    apply: () => ({ name:'rebooking_pcc', title:'REBOOKING ENTRE PCCs',
      forms:[{ form:'form1', title:'DATOS', title_visible:true, remarks:[
        mkField({ label:'PNR original', mandatory:true }),
        mkField({ label:'PCC destino', mandatory:true })
      ]}], postCommands:['*{{field_0}}','*A','*PQ','AAA {{field_1}}','WC*','WPNI','*A','ER'], validateActiveReservation:false, sendCommands:true }) },
  { id:'op_pcc_change', category:'Operacionales', title:'Cambio de PCC', description:'Cambiar el area de trabajo activa a otro PCC.',
    apply: () => ({ name:'cambio_pcc', title:'CAMBIO DE PCC',
      forms:[{ form:'form1', title:'PCC', title_visible:true, remarks:[
        mkField({ label:'Nuevo PCC', mandatory:true })
      ]}], postCommands:['AAA {{field_0}}','*A'], validateActiveReservation:false, sendCommands:true }) },
  { id:'op_markup_low_cost', category:'Operacionales', title:'Markup VivaAerobus / low cost', description:'Remarks de markup tipico para vuelos low-cost.',
    apply: () => ({ name:'markup_vivaaerobus', title:'MARKUP VIVAAEROBUS',
      forms:[{ form:'form1', title:'MARKUP', title_visible:true, remarks:[
        mkField({ label:'Monto markup', remark_mask:'5-MARKUP VB ', typeremark:'Invoice', mandatory:true }),
        mkField({ label:'Numero confirmacion Viva', remark_mask:'5-VB CONF ', typeremark:'Invoice', mandatory:true })
      ]}], postCommands:['ER'], validateActiveReservation:true }) },
  { id:'op_dk_validation', category:'Operacionales', title:'Validar DK + remark de aprobacion', description:'Lee DK actual, valida y deja constancia.',
    apply: () => ({ name:'dk_validation', title:'VALIDAR DK',
      forms:[{ form:'form1', title:'DK', title_visible:true, remarks:[
        mkField({ label:'Justificacion', remark_mask:'5H-DK VALIDADO - ', typeremark:'Historical', mandatory:true })
      ]}], postCommands:['*PDK','ER'], validateActiveReservation:true, sendCommands:true }) },
  { id:'op_rfc_mexico', category:'Operacionales', title:'Documentacion RFC Mexico', description:'Datos fiscales mexicanos: RFC, regimen, uso de CFDI.',
    apply: () => ({ name:'rfc_mexico', title:'DOCUMENTACION RFC',
      forms:[{ form:'form1', title:'DATOS FISCALES MX', title_visible:true, remarks:[
        mkField({ label:'RFC (13 chars)', remark_mask:'5-RFC ', typeremark:'Invoice', mandatory:true }),
        mkField({ label:'Razon social', remark_mask:'5-RAZ SOC ', typeremark:'Invoice', mandatory:true }),
        mkField({ label:'Codigo postal', remark_mask:'5-CP ', typeremark:'Invoice', mandatory:true }),
        mkField({ label:'Uso CFDI', typedata:'select', remark_mask:'5-USO CFDI ', typeremark:'Invoice', mandatory:true, datasource:[
          {value:'G01',text:'G01 - Adquisicion de mercancias'},
          {value:'G03',text:'G03 - Gastos en general'},
          {value:'D01',text:'D01 - Honorarios medicos'},
          {value:'P01',text:'P01 - Por definir'}
        ]}),
        mkField({ label:'Regimen fiscal', typedata:'select', remark_mask:'5-REG FISCAL ', typeremark:'Invoice', mandatory:true, datasource:[
          {value:'601',text:'601 - Personas Morales'},
          {value:'603',text:'603 - Sin fines de lucro'},
          {value:'605',text:'605 - Sueldos y Salarios'},
          {value:'612',text:'612 - PF Actividades Empresariales'},
          {value:'626',text:'626 - RESICO'}
        ]})
      ]}], postCommands:['ER'], validateActiveReservation:true }) },
  { id:'op_centro_costo', category:'Operacionales', title:'Centro de costo + Aprobador', description:'Datos contables para facturacion corporativa.',
    apply: () => ({ name:'centro_costo', title:'CENTRO DE COSTO',
      forms:[{ form:'form1', title:'FACTURACION', title_visible:true, remarks:[
        mkField({ label:'Centro de costo', remark_mask:'5-CC ', typeremark:'Invoice', mandatory:true }),
        mkField({ label:'Aprobador', remark_mask:'5-APR ', typeremark:'Invoice', mandatory:true }),
        mkField({ label:'Numero orden de compra', remark_mask:'5-OC ', typeremark:'Invoice', mandatory:false })
      ]}], postCommands:['ER'], validateActiveReservation:true }) },
  { id:'op_split_pnr', category:'Operacionales', title:'Split PNR (dividir)', description:'Divide un PNR en dos: separa pasajeros.',
    apply: () => ({ name:'split_pnr', title:'SPLIT PNR',
      forms:[{ form:'form1', title:'SPLIT', title_visible:true, remarks:[
        mkField({ label:'Numero(s) pasajero a separar (ej 2 o 2,3)', remark_mask:'D', mandatory:true })
      ]}], postCommands:['*A','F','ER'], validateActiveReservation:true, sendCommands:true }) },
];

export { COMMANDS, TEMPLATES, SAMPLE_SST, API_TABS, SABRE_CMD_CATALOG, FIELD_TYPES, REMARK_TYPES, RECIPES }
